import type { Context } from 'react';
import { createContext } from 'react';

import type { FireFeedCardAnalyticsEvent } from '../useFeedCardAnalyticsEvents.ts';

type FeedCardContextType = {
	fireAnalyticsEvent: FireFeedCardAnalyticsEvent;
};

export const FeedCardContext: Context<FeedCardContextType> = createContext<FeedCardContextType>({
	fireAnalyticsEvent: () => {},
});
